import React from "react";

import {
  CheckCircle as CheckCircleIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from "@mui/icons-material";
import {
  Box,
  Step,
  StepButton,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import { useRecipe } from "../store/RecipeStore";

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: theme.spacing(3),
    border: "2px solid #EDF0F5",
    backgroundColor: colors.white,
    boxShadow: "6px 6px 0 0 #EDF0F5",
    // This is triangle in top-left for the draped-like effect
    "&:after": {
      position: "absolute",
      top: 0,
      left: -8,
      borderLeft: "10px solid transparent",
      borderBottom: "10px solid #D4DBE5",
      content: "''",
    },
  },
}));

const RecipeStepConnector = withStyles(
  StepConnector,
  (_theme, _params, classes) => ({
    active: {
      [`& .${classes.line}`]: {
        borderColor: colors.primary,
      },
    },
    completed: {
      [`& .${classes.line}`]: {
        borderColor: colors.primary,
      },
    },
    line: {
      borderColor: "#B8BEC9",
      borderTopWidth: 2,
      borderRadius: 5,
      minWidth: 50, // To make the line still appear when component is not minimum width
    },
  })
);

const RecipeStepIcon: React.FC<StepIconProps> = ({ completed, active }) => {
  const renderIcon = () => {
    if (active) return <CheckCircleOutlineIcon fontSize="small" />;
    if (completed) return <CheckCircleIcon fontSize="small" />;
    return <RadioButtonUncheckedIcon fontSize="small" />;
  };

  return <Box color={colors.primary}>{renderIcon()}</Box>;
};

const STEPS = [
  { key: "details", label: "Recipe Details" },
  { key: "instructions", label: "Cooking Instructions" },
];

const RecipeFormStepper: React.FC = () => {
  const recipe = useRecipe();
  const { classes } = useStyles();

  return (
    <Box
      alignItems="stretch"
      display="flex"
      flex={1}
      flexDirection="column"
      height="100%"
      position="relative"
    >
      <Box className={classes.root}>
        <Stepper
          nonLinear
          connector={<RecipeStepConnector />}
          activeStep={recipe.step.activeStep}
        >
          {STEPS.map((step, index) => (
            <Step key={step.label} completed={recipe.step.completedStep[index]}>
              <StepButton onClick={() => (recipe.step.setStep = index)}>
                <StepLabel StepIconComponent={RecipeStepIcon}>
                  {step.label}
                </StepLabel>
              </StepButton>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default observer(RecipeFormStepper);
